import React from 'react';

import PropTypes from 'prop-types';

import * as APPDATA from '@/constants/pcConstAppData';
import UseIsDemoMode from '@/hooks/useIsDemoMode';

import {CALIBRATION_WIZARD_CONTENT} from '../../../constants/calibrationWizardConstant';

function Welcome({onClickCheckOrCalibrateScale}) {
  const isDemoMode = UseIsDemoMode();
  return (
    <div className="calibration-wizzard wizard-welcome">
      <div className="center">
        <h2>
          <b>
            Welcome to the {APPDATA.MESSAGES.PRODUCT_NAME}
            <sup>
              <b>®</b>
            </sup>{' '}
            Scale Calibration Wizard!
          </b>
        </h2>
      </div>
      <div className="row-content center">
        It is recommended that you check the scale accuracy using the calibration weight, especially when you:
        <br />- Install the {APPDATA.MESSAGES.PRODUCT_NAME} instrument for the first time.
        <br />
        - Move the instrument to a different room temperature and allow it to acclimate for at least two hours.
        <br />- Experience volume inaccuracy issues during a profile execution.
      </div>
      <div className="row-content center">
        <span className="content">
          If any inaccuracy is found, select {APPDATA.FIELD_NAME.CALIBRATE_SCALES.toUpperCase()} to proceed with the
          calibration.
        </span>
      </div>
      <div className="row-content center">
        <span className="content">
          <b>
            Before starting the calibration, please prepare the calibration weight.
            <br />
            If you don’t have the calibration weight, prepare a tube, a tube stand, water, and
            <br />a scale accurate to 2 decimal points.
          </b>
        </span>
      </div>
      <div className="row-button div-2col">
        <button
          type="button"
          className="checkScaleButton button"
          onClick={() => onClickCheckOrCalibrateScale(CALIBRATION_WIZARD_CONTENT.CheckScales)}
        >
          {APPDATA.FIELD_NAME.CHECK_SCALES.toUpperCase()}
        </button>
        <button
          type="button"
          className="calibrateScaleButton button"
          onClick={() => onClickCheckOrCalibrateScale(CALIBRATION_WIZARD_CONTENT.CalibrateScale)}
          disabled={isDemoMode}
        >
          {APPDATA.FIELD_NAME.CALIBRATE_SCALES.toUpperCase()}
        </button>
      </div>
    </div>
  );
}
Welcome.propTypes = {
  onClickCheckOrCalibrateScale: PropTypes.func,
};
Welcome.defaultProps = {
  onClickCheckOrCalibrateScale: () => {},
};
export default Welcome;
